import { PUB_SUB_CHANNEL_APP } from '@wix/communities-blog-client-common/dist/src/constants/pub-sub-channels';
import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { setIsSaving } from './set-is-saving';

export const SAVE_AND_PUBLISH_POST = 'post/SAVE_AND_PUBLISH';

const saveAndPublish = createAction(
  SAVE_AND_PUBLISH_POST,
  values => values,
  () => ({
    publish: [PUB_SUB_CHANNEL_APP],
  }),
);

export const saveAndPublishPost = values => dispatch => {
  dispatch(setIsSaving(true));
  return dispatch(saveAndPublish(values));
};
